import { NgModule } from '@angular/core';

import { NotificationsComponent } from './notifications.component';
import { NotificationsService }   from './notifications.service';
import { SharedModule }           from '../../shared/shared.module';

@NgModule({
  declarations: [
    NotificationsComponent
  ],
  entryComponents: [
    NotificationsComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    NotificationsService
  ]
})
export class NotificationsModule {}
